import React from "react";
import MenuCommerceCartBar from "./MenuCommerceCartBar";
import MenuCommerceSummaryModal from "./MenuCommerceSummaryModal";

const MenuCommerceCart = ({
  cart,
  currency,
  summary,
  setSummary,
  observations,
  setObservations,
  deliveryPoint,
  setDeliveryPoint,
  askForDeliveryPoint = true,
  deliveryPointEditable = true,
  defaultDeliveryPointCode = "",
  isDeliveryPointMissing = false,
  cartItemsCustomizations,
  language,
  addItem,
  removeItem,
  updateCustomization,
  resetCart,
  openSummary,
  closeSummary,
  submitRequest,
  sending,
  submissionState = "idle",
  redirectCountdown = 3,
  onImmediateRedirect,
  submitLabel,
  missingCustomizations,
  hasCustomizableItems,
  hasMissingCustomizations,
  showCartSummary = true,
}) => {
  if (!cart?.qty) {
    return null;
  }

  return (
    <>
      <MenuCommerceCartBar
        cart={cart}
        currency={currency}
        submitLabel={submitLabel}
        hasCustomizableItems={hasCustomizableItems}
        onOpenSummary={openSummary}
        onResetCart={resetCart}
        sending={sending}
      />

      <MenuCommerceSummaryModal
        open={summary}
        onClose={closeSummary || (() => setSummary(false))}
        cart={cart}
        language={language}
        currency={currency}
        observations={observations}
        setObservations={setObservations}
        deliveryPoint={deliveryPoint}
        setDeliveryPoint={setDeliveryPoint}
        askForDeliveryPoint={askForDeliveryPoint}
        deliveryPointEditable={deliveryPointEditable}
        defaultDeliveryPointCode={defaultDeliveryPointCode}
        isDeliveryPointMissing={isDeliveryPointMissing}
        customizations={cartItemsCustomizations}
        missingCustomizations={missingCustomizations}
        hasMissingCustomizations={hasMissingCustomizations}
        hasCustomizableItems={hasCustomizableItems}
        showCartSummary={showCartSummary}
        onAddItem={addItem}
        onRemoveItem={removeItem}
        onUpdateCustomization={updateCustomization}
        onSubmit={submitRequest}
        sending={sending}
        submissionState={submissionState}
        redirectCountdown={redirectCountdown}
        onImmediateRedirect={onImmediateRedirect}
        submitLabel={submitLabel}
      />
    </>
  );
};

export default MenuCommerceCart;
